import { AxiosResponse } from 'axios';

import httpRequest from 'api/base';
import HTTPEndPoints from 'api/httpEndpoints';
import { HTTPVerbs } from 'api/types';
import { VehicleQueryParam } from 'app/domain/loan/slice/interfaces';

import {
  BrandsResponse,
  CalculateInstallmentPayload,
  CollateralPayload,
  CollateralResponse,
  InstallmentResponse,
  ModelsResponse,
  ProductListsParams,
  ProductListsResponse,
  ProvinceCityResponse,
  ProvinceResponse,
  SearchCityResponse,
  VariantResponse,
  Vehicle,
  YearsResponse,
} from './interfaces';

class Vehicles implements Vehicle {
  async getVehicleBrands(
    params: VehicleQueryParam,
  ): Promise<AxiosResponse<BrandsResponse>> {
    const path = HTTPEndPoints.getVehicleBrands();
    const method = HTTPVerbs.GET;
    const result = await httpRequest({ path, method, params });
    return result.data;
  }

  async getVehicleModels(
    brandAssetCode: string,
    params: VehicleQueryParam,
  ): Promise<AxiosResponse<ModelsResponse>> {
    const path = HTTPEndPoints.getVehicleModel(brandAssetCode);
    const method = HTTPVerbs.GET;
    const result = await httpRequest({ path, method, params });
    return result.data;
  }

  async getVehicleVariants(
    modelCode: string,
    params: VehicleQueryParam,
  ): Promise<AxiosResponse<VariantResponse>> {
    const path = HTTPEndPoints.getVehicleVariant(modelCode);
    const method = HTTPVerbs.GET;
    const result = await httpRequest({ path, method, params });
    return result.data;
  }

  async getVehicleYears(): Promise<AxiosResponse<YearsResponse>> {
    const path = HTTPEndPoints.getVehicleYear();
    const method = HTTPVerbs.GET;
    const result = await httpRequest({ path, method });
    return result.data;
  }

  async getVehicleProvince(
    params: VehicleQueryParam,
  ): Promise<AxiosResponse<ProvinceResponse>> {
    const path = HTTPEndPoints.getVehicleProvince();
    const method = HTTPVerbs.GET;
    const result = await httpRequest({ path, method, params });
    return result.data;
  }

  async getVehicleProvinceCity(
    provinceCode: string | null,
    params: VehicleQueryParam,
  ): Promise<AxiosResponse<ProvinceCityResponse>> {
    const path = HTTPEndPoints.getVehicleProvinceCity(provinceCode);
    const method = HTTPVerbs.GET;
    const result = await httpRequest({ path, method, params });
    return result.data;
  }

  async getSearchCity(
    params: VehicleQueryParam,
  ): Promise<AxiosResponse<SearchCityResponse>> {
    const path = HTTPEndPoints.getSearchCity();
    const method = HTTPVerbs.GET;
    const result = await httpRequest({ path, method, params });
    return result.data;
  }

  async getVehicleProductLists(
    params: ProductListsParams,
  ): Promise<AxiosResponse<ProductListsResponse>> {
    const path = HTTPEndPoints.getProductLists();
    const method = HTTPVerbs.GET;
    const result = await httpRequest({ path, method, params });
    return result;
  }

  async postVehicleCollateral(
    data: CollateralPayload,
  ): Promise<AxiosResponse<CollateralResponse>> {
    const path = HTTPEndPoints.postCollateral();
    const method = HTTPVerbs.POST;
    const result = await httpRequest({ path, method, data });
    return result;
  }

  async postCalculateInstallment(
    data: CalculateInstallmentPayload,
  ): Promise<AxiosResponse<InstallmentResponse>> {
    const path = HTTPEndPoints.postCalculateInstallment();
    const method = HTTPVerbs.POST;
    const result = await httpRequest({ path, method, data });
    return result;
  }
}

const VehiclesAPI = new Vehicles();
export default VehiclesAPI;
